
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/mycrashbaggage/webapps/mycrashbaggage/sentry.client.config.ts")
            }
          });